<script>
import login from '~/pages/_lang/login/index'
export default login
</script>
